import RsAlertEventBus from './events'
import { AlertSymbol } from './hooks/useAlert'

import RsAlert from './components/RsAlert'

export { useAlert } from './hooks/useAlert'

export const createAlert = () => ({
    install: (app) => {
      const AlertService = {
        add: (message) => {
          RsAlertEventBus.emit('add', message)
        },
        removeGroup: (group) => {
          RsAlertEventBus.emit('remove-group', group)
        },
        removeAllGroups: () => {
          RsAlertEventBus.emit('remove-all-groups')
        }
      }
      app.config.globalProperties.$alert = AlertService
      app.provide(AlertSymbol, AlertService)
    }
  }
)

export default RsAlert
